// Components
import { EditIcon } from '@/icons';
import { StyledActionButton } from '@/components';
import { StyledActionsWrap } from './RegionTableActionsStyles';
import { Link } from '@/ui';

// Models
import { IRegion } from '@/models/regions.model';
import { ROUTES } from '@/models/router.model';

// Helpers
import { COLORS } from '@/theme';

type TRegionTableActions = {
  record: IRegion;
};

const RegionTableActions = ({ record }: TRegionTableActions) => {
  return (
    <StyledActionsWrap>
      <Link path={`${ROUTES.REGION}/${record.id}`}>
        <StyledActionButton $color={COLORS.PALE_YELLOW}>
          <EditIcon />
        </StyledActionButton>
      </Link>
    </StyledActionsWrap>
  );
};

export default RegionTableActions;
